import {ReactNode} from "react";

interface CardGridProps {
    children: ReactNode;
    className?: string;
    gap?: 2 | 4 | 6 | 8;
    equalHeight?: boolean;
}

export const CardGrid= ({
                            children,
                            className = '',
                            gap = 4,
                            equalHeight = true,
                        }: CardGridProps) => {
    const gapClasses = {
        2: 'gap-2',
        4: 'gap-4',
        6: 'gap-6',
        8: 'gap-8'
    };

    const gapClass = gapClasses[gap];

    return (
        <div className={`grid grid-cols-1 md:grid-cols-3 ${gapClass} ${className} ${equalHeight ? 'grid-flow-row-dense' : ''}`}>
            {children}
        </div>
    );
};
